import { c as _c } from "react/compiler-runtime";
import Button from '@module/components/Button/Button';
import { cn } from '@module/lib/utils';
import { usePostSubtitleRequestHangulMutation } from '@module/queries/subtitle/subtitleQueryHooks';
import useSocketStore from '@module/stores/useSocketStore';
import type { LangCode } from '@module/types/centrifuge/public-message';
import catchAllErrors from '@module/utils/catchAllErrors';
import { useState } from 'react';
interface Props {
  nickname: string;
  setTranslatedNickname: (nickname: string) => void;
  srcLang: LangCode;
  className?: string;
}
function NickTranslateButton(t0) {
  const $ = _c(16);
  const {
    nickname,
    setTranslatedNickname,
    srcLang,
    className
  } = t0;
  const token = useSocketStore(_temp);
  const [isTranslated, setIsTranslated] = useState(false);
  let t1;
  if ($[0] !== setTranslatedNickname) {
    t1 = {
      onSuccess: data => {
        setTranslatedNickname(data.hangulizedText);
        setIsTranslated(true);
      },
      onError: _temp2
    };
    $[0] = setTranslatedNickname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutate,
    isPending
  } = usePostSubtitleRequestHangulMutation(t1);
  const buttonText = srcLang === "ja" ? "\uD55C\uAE00\uBC1C\uC74C" : "\u65E5\u672C\u767A\u97F3";
  let t2;
  if ($[2] !== className) {
    t2 = cn("!flex 0 h-[15px] min-w-[42px] rounded-[5px] border-0 bg-colorIco23 px-[2px] py-0 text-cht_baseFg leading-none hover:no-underline disabled:bg-colorBg06 disabled:text-colorFg16", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mutate || $[5] !== nickname || $[6] !== token) {
    t3 = e => {
      e.stopPropagation();
      if (!token) {
        return;
      }
      mutate({
        text: nickname
      });
    };
    $[4] = mutate;
    $[5] = nickname;
    $[6] = token;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== buttonText) {
    t4 = <Button.Text className="font-normal text-[10px] ">{buttonText}</Button.Text>;
    $[8] = buttonText;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isPending || $[11] !== isTranslated || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Button height="small" className={t2} onClick={t3} isPending={isPending} disabled={isTranslated}>{t4}</Button>;
    $[10] = isPending;
    $[11] = isTranslated;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function _temp2(error) {
  catchAllErrors(error);
}
function _temp(state) {
  return state.token;
}
export default NickTranslateButton;